var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallieni({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 258.166,
    height: 47.13,
    viewBox: "0 0 258.166 47.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 258.166,
    height: 47.13,
    fill: "#1d3d88"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_245",
    "data-name": "Groupe 245",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_150",
    "data-name": "Trac\\xE9 150",
    d: "M469.871,43.5V55.214H484.65V43.5l-7.39-2.6Z",
    transform: "translate(-226.484 -19.716)",
    fill: "#900e35"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 11.782,
    height: 47.13,
    transform: "translate(221.639 0)",
    fill: "#676fd1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 36.524,
    height: 11.783,
    transform: "translate(221.642 -0.001)",
    fill: "#8b6711"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 36.524,
    height: 11.782,
    transform: "translate(221.642 35.348)",
    fill: "#1d3d88"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_246",
    "data-name": "Groupe 246",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_245-2",
    "data-name": "Groupe 245",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_151",
    "data-name": "Trac\\xE9 151",
    d: "M31.07,16.919H7.33V19.65H28.252a9.171,9.171,0,0,1-.141,1,12.583,12.583,0,0,1-12.47,10.426,13.3,13.3,0,0,1-2.386-.22A12.652,12.652,0,0,1,3.17,15.941a12.364,12.364,0,0,1,1.819-4.763,12.734,12.734,0,0,1,10.65-5.895A12.8,12.8,0,0,1,24.7,9.115a3.644,3.644,0,0,1,.628.66l.417.585,2.074-1.92-.4-.463c-.128-.149-.257-.289-.385-.427s-.233-.252-.383-.426A15.3,15.3,0,0,0,12.443,2.883a15.436,15.436,0,0,0-9.9,6.788A15.48,15.48,0,0,0,.254,15.366,15.854,15.854,0,0,0,2.8,27.285a15.07,15.07,0,0,0,12.349,6.5c.164,0,.326.007.491.007h0A15.228,15.228,0,0,0,31.2,18.408a6.406,6.406,0,0,0-.048-.946Z",
    transform: "translate(0 -1.226)",
    fill: "#1d3d88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_152",
    "data-name": "Trac\\xE9 152",
    d: "M72.425,32.6h3.228l5.781-12.91H92.67L98.452,32.6h3.226L87.051.68ZM91.565,17h-9.02L87.088,7.21Z",
    transform: "translate(-34.91 -0.328)",
    fill: "#1d3d88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_153",
    "data-name": "Trac\\xE9 153",
    d: "M149.99,3.253H147.1V33.838h13.727V31.066H149.99Z",
    transform: "translate(-70.902 -1.568)",
    fill: "#1d3d88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_154",
    "data-name": "Trac\\xE9 154",
    d: "M196.469,3.253h-2.895V33.838H207.3V31.066H196.469Z",
    transform: "translate(-93.306 -1.568)",
    fill: "#1d3d88"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 2.894,
    height: 30.586,
    transform: "translate(124.345 1.684)",
    fill: "#1d3d88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_155",
    "data-name": "Trac\\xE9 155",
    d: "M271.765,19.87H285V17.181H271.765V6.024h13.316V3.253H268.913V33.838H285.45V31.107H271.765Z",
    transform: "translate(-129.619 -1.568)",
    fill: "#1d3d88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_156",
    "data-name": "Trac\\xE9 156",
    d: "M343.8,25.982,323.4,0V32.27h2.893V8.069l20.4,26.227V1.685H343.8Z",
    transform: "translate(-155.881 0)",
    fill: "#1d3d88"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 2.892,
    height: 30.586,
    transform: "translate(202.864 1.684)",
    fill: "#1d3d88"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 0.622,
    height: 9.755,
    transform: "translate(139.837 37.051)",
    fill: "#1d3d88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_157",
    "data-name": "Trac\\xE9 157",
    d: "M282.642,72.911h-.025l-3.4,8.4-3.39-8.4H275.8l-1.668,8.073h-.6l2.1-10.078,3.583,8.875,3.6-8.875,2.1,10.078h-.595Z",
    transform: "translate(-131.847 -34.178)",
    fill: "#1d3d88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_158",
    "data-name": "Trac\\xE9 158",
    d: "M305.172,72.911h-.026l-3.4,8.4-3.39-8.4h-.026l-1.669,8.073h-.6l2.1-10.078,3.584,8.875,3.6-8.875,2.1,10.078h-.595Z",
    transform: "translate(-142.707 -34.178)",
    fill: "#1d3d88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_159",
    "data-name": "Trac\\xE9 159",
    d: "M329.387,76.286a5.058,5.058,0,1,1-5.059-5.007,5.08,5.08,0,0,1,5.059,5.007m-9.5,0a4.438,4.438,0,1,0,4.438-4.425,4.467,4.467,0,0,0-4.438,4.425",
    transform: "translate(-153.893 -34.358)",
    fill: "#1d3d88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_160",
    "data-name": "Trac\\xE9 160",
    d: "M341.848,81.284V71.529H343.8a2.811,2.811,0,0,1,2.018.57,2.554,2.554,0,0,1,.815,2.018,2.11,2.11,0,0,1-1.126,1.992,2.452,2.452,0,0,1,2.019,2.458,2.577,2.577,0,0,1-.907,2.019,3.215,3.215,0,0,1-2.277.7Zm.621-5.331h1.074a2.641,2.641,0,0,0,1.747-.362,1.718,1.718,0,0,0,.726-1.565,1.834,1.834,0,0,0-.8-1.6,3.069,3.069,0,0,0-1.669-.31h-1.074Zm0,4.748h1.488a3.416,3.416,0,0,0,1.992-.375,2.058,2.058,0,0,0,.957-1.734,1.915,1.915,0,0,0-1.009-1.746,4.828,4.828,0,0,0-2.057-.311h-1.372Z",
    transform: "translate(-164.775 -34.478)",
    fill: "#1d3d88"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 0.621,
    height: 9.755,
    transform: "translate(184.448 37.051)",
    fill: "#1d3d88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_161",
    "data-name": "Trac\\xE9 161",
    d: "M362.078,80.7h2.484v.582h-3.1V71.529h.621Z",
    transform: "translate(-174.227 -34.478)",
    fill: "#1d3d88"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 0.621,
    height: 9.755,
    transform: "translate(191.525 37.051)",
    fill: "#1d3d88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_162",
    "data-name": "Trac\\xE9 162",
    d: "M375.74,72.112v3.545h3.933v.583H375.74V80.7h4.037v.582h-4.658V71.53h4.658v.582Z",
    transform: "translate(-180.812 -34.479)",
    fill: "#1d3d88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_163",
    "data-name": "Trac\\xE9 163",
    d: "M392.733,81.284h-.711l-3.182-4.619h-.31v4.619h-.622V71.529h1.216a3.592,3.592,0,0,1,2.225.492,2.61,2.61,0,0,1-1.811,4.645Zm-3.416-5.2a2.434,2.434,0,0,0,1.708-.453,1.953,1.953,0,0,0,.686-1.54,1.863,1.863,0,0,0-1.035-1.759,4.169,4.169,0,0,0-1.747-.22h-.4v3.971Z",
    transform: "translate(-186.976 -34.478)",
    fill: "#1d3d88"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallieni);
export default __webpack_public_path__ + "static/media/gallieni.5ac8e6c514965dea1690ac27616c88ba.svg";
export { ForwardRef as ReactComponent };